import './send-invitation-form.scss';

import { useState } from 'react';

function SendInvitationForm({
  onSendInvitation,
  isLoading,
  statusMessage,
  messageType,
}) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const validateEmail = (emailValue) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailValue);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (emailError) setEmailError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setEmailError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    onSendInvitation(email.trim());
    setEmail('');
    setEmailError('');
  };

  return (
    <div className="send-invitation-section">
      <h4 className="send-invitation-title">Send a new invitation</h4>

      <form onSubmit={handleSubmit} className="send-invitation-form">
        <div className="form-group">
          <input
            type="email"
            className={`form-control ${emailError ? 'error' : ''}`}
            placeholder="Enter Email"
            value={email}
            onChange={handleEmailChange}
            disabled={isLoading}
          />
          {emailError && <div className="error-message">{emailError}</div>}
        </div>

        <button
          type="submit"
          className="btn btn-primary send-request-btn"
          disabled={isLoading || !email.trim()}
        >
          {isLoading ? 'SENDING...' : 'SEND REQUEST'}
        </button>
      </form>

      {statusMessage && (
        <div className={`status-message ${messageType}`}>{statusMessage}</div>
      )}
    </div>
  );
}

export default SendInvitationForm;
